import Sort from "./KrSort.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrSort = install(Sort); // 生成带有 install 方法的组件

export default KrSort;
